import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SelectEvent } from '@progress/kendo-angular-upload';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { DocumentService } from 'src/app/shared/services/documents/document.service';

@Component({
  selector: 'app-member-doc-upload',
  templateUrl: './member-doc-upload.component.html',
  styleUrls: ['./member-doc-upload.component.css']
})
export class MemberDocUploadComponent implements OnInit {
  fileRestrictions: any;
  config: any;
  maxFiles: any;
  errorMessages = [];
  allFiles = [];
  currentSelection = [];
  show = false;
  maxFilesMessage: any;
  selectedFilesCount = 0;
  operators: any;
  value = 0;
  chunkCount = 1;
  disableSubmitBtn: boolean;
  validationErrors: boolean;

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    private documentService: DocumentService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.config = this.readConfigService.getMemberDocFileUpload();
    this.fileRestrictions = this.config.BatchFileRestrictions;
    this.operators = this.authService.getAccessOperations(2);
    this.maxFiles = this.config.MaxFilesAllowed ? this.config.MaxFilesAllowed : 10;
  }

  onFileSelect(e: SelectEvent) {
    this.value = 0;
    if (e && e.files && e.files.length > 0) {
      this.selectedFilesCount = this.selectedFilesCount + e.files.length;
      this.chunkCount = this.selectedFilesCount > 10 ? 10 : this.selectedFilesCount;
      this.allFiles = this.allFiles.concat(e.files);
      this.value = this.allFiles.length > 0 ? this.value : 0;
      this.validationErrors = this.allFiles.find((s: any) => s.validationErrors);
      this.checkNumberofFiles(e.files, true);
    }
  }

  checkNumberofFiles(files: any, addToCurrent: boolean) {
    this.maxFilesMessage = null;
    if (this.selectedFilesCount > this.config.MaxFilesAllowed) {
      this.maxFilesMessage = this.config.MaxFilesMessage.replace('{0}', this.selectedFilesCount)
        .replace('{1}', this.config.MaxFilesAllowed);
    } else {
      if (addToCurrent) {
        this.currentSelection = files;
      }
    }
    this.checkDuplicateFileName();
  }

  checkDuplicateFileName() {
    // check duplicate file name
    this.errorMessages = [];
    this.allFiles.forEach((element: any) => {
      const tempArr = this.allFiles.filter((s: any) => s.name === element.name);
      if (tempArr.length > 1) {
        this.currentSelection = this.currentSelection.filter((s: any) => s.name !== element.name);
        this.errorMessages.push({ fileName: element.name, validationId: 4 });
      }
    });
  }

  getValidationMessage(id: number) {
    return this.config.ValidationMessages.find((s: any) => s.id === id).text;
  }

  uploadBatch(upload: any) {
    this.disableSubmitBtn = true;
    this.show = true;
    this.notificationService.setUpLoading(true);
    this.documentService.uploadMemberDocBatch(JSON.stringify(this.usersService.UserInfo()), this.allFiles).subscribe((response: any) => {
      if (response && response.statusCode === 200 && response.result) {
        const result = response.result;
        if (result.length > 0) {
          this.value = this.value - (result.length * 10);
          result.forEach((element: any) => {
            if (element.validationId > 0) {
              this.errorMessages.push(element);
            }
          });
        } else {
          this.onClearButtonClick(upload);
          this.value = 100;
          this.notificationService.setUpNotification({ message: 'Upload successful.', success: true });
        }
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
      this.disableSubmitBtn = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.disableSubmitBtn = false;
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  removeEventHandler(e: any) {
    const removedFiles = e.files;
    if (removedFiles.length > 0) {
      this.selectedFilesCount--;
      this.chunkCount = this.selectedFilesCount > 10 ? 10 : this.selectedFilesCount;
      this.allFiles.forEach((element: any, index: number) => {
        if (removedFiles[0].uid === element.uid) {
          this.allFiles.splice(index, 1);
        }
      });
      this.validationErrors = this.allFiles.find((s: any) => s.validationErrors);
      this.checkNumberofFiles(this.allFiles, false);
    }
  }

  onClearButtonClick(upload: any) {
    this.allFiles = [];
    this.errorMessages = [];
    this.selectedFilesCount = 0;
    this.chunkCount = 1;
    this.maxFilesMessage = null;
    upload.clearFiles();
  }
}
